import { useRef } from 'react';
import '../Footer/Footer.scss'

import { Link } from 'react-router-dom';

const Footer = ({selectGadjetType}) =>{
     
   
return (
        <>
            
            <footer className="footer">
                <div className='footer__container'>
                <div className='footer__top'>
                    <div className='footer__top-group'>
                        <h3 className='footer__top-title'>Products</h3>
                        <Link style={{textDecoration:'none', color: '#fff'}} to='/home' onClick={()=>{selectGadjetType('iphones')}} ><p className='footer__top-item'>Iphones</p></Link>
                        <Link style={{textDecoration:'none', color: '#fff'}} to='/home' onClick={()=>{selectGadjetType('ipads')}}><p className='footer__top-item'>Ipads</p></Link>
                        <Link style={{textDecoration:'none', color: '#fff'}} to='/home' onClick={()=>{selectGadjetType('macbooks')}}><p className='footer__top-item'>Macbooks</p></Link>
                        <Link style={{textDecoration:'none', color: '#fff'}} to='/home' onClick={()=>{selectGadjetType('apple watches')}}><p className='footer__top-item'>Apple Watches</p></Link>
                        
                    </div>
                    <div className='footer__top-group'>
                        <h3 className='footer__top-title'>Services</h3>
                        <Link style={{textDecoration:'none', color: '#fff'}} to='/contact'><p className='footer__top-item'>Repair</p></Link>
                        <Link style={{textDecoration:'none', color: '#fff'}} to='/contact'><p className='footer__top-item'>Trade IN</p></Link>
                    </div>
                    <div className='footer__top-group'>
                        <h3 className='footer__top-title'>Information</h3>
                        <Link style={{textDecoration:'none', color: '#fff'}} to='/vacancies'><p className='footer__top-item'>Jobs</p></Link>
                        <Link style={{textDecoration:'none', color: '#fff'}} to='/contact'><p className='footer__top-item'>Warranty and service</p></Link>
                        <Link style={{textDecoration:'none', color: '#fff'}} to='/contact'><p className='footer__top-item'>Contacts</p></Link>
                    </div>
                </div>
                </div>
                <p className="footer__text">Copyright &#169; U Store, 2023</p>
             </footer>
        </>
)
}

export default Footer;